import React from 'react'
import {FaFacebookF, FaTwitter, FaLinkedin} from 'react-icons/fa'


export const socialData=[
    {
        id:1,
        icon: <FaFacebookF className="icon"></FaFacebookF>,
        url: 'https://www.facebook.com'
    },
    {
        id:2,
        icon:<FaTwitter className="icon"></FaTwitter>,
        url: 'https://www.twitter.com'
    },
    {
        id: 3,
        icon: <FaLinkedin className="icon"></FaLinkedin>,
        url: 'https://www.linkedin.com'
    }
]